import useTranslation from 'next-translate/useTranslation';

//hooks
import useActiveGroup from '@/utils/hooks/user/useActiveGroup';

import { X } from '@/lib/socialProfile';
// Lib
import { RESTRICTED_NETWORKS } from '@/lib/socialProfile/restrictedNetworks';

import Badge from '@/components/base/Badge';
// Components
import CompoundBanner from '@/components/base/InfoBanner/CompoundBanner';

export function RestrictedNetworksWarningBanner() {
    const { t } = useTranslation('commons');
    const { activeGroup } = useActiveGroup();

    const restrictedNetworksInGroup = new Set<string>();

    activeGroup?.social_profiles?.forEach((socialProfile) => {
        if (
            RESTRICTED_NETWORKS.includes(socialProfile.social_network_type) &&
            socialProfile.active
        ) {
            restrictedNetworksInGroup.add(socialProfile.social_network_type);
        }
    });

    if (restrictedNetworksInGroup.size > 0) {
        const networkNames = Array.from(restrictedNetworksInGroup)
            .map((network) => {
                return network === X ? 'X' : 'Threads';
            })
            .join(', ');

        return (
            <CompoundBanner type="warning">
                <CompoundBanner.Icon>
                    <Badge variant="important" />
                </CompoundBanner.Icon>
                <CompoundBanner.Content
                    message={t('group_restricted_profiles_warning_banner.message', {
                        networks: networkNames
                    })}
                />
            </CompoundBanner>
        );
    }

    return null;
}
